import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import DescriptionIcon from '@mui/icons-material/Description';
import Tooltip from '@mui/material/Tooltip';
import AgreementDialog from './AgreementDialog';

interface ClickableAgreementIdProps {
  agreementId: string;
  onAgreementUpdated?: () => void;
  useAsId?: boolean;
}

/**
 * A component that displays an icon that opens the AgreementDialog when clicked.
 *
 * @param agreementId - The ID of the agreement to open
 * @param onAgreementUpdated - Optional callback when an agreement is updated
 * @param useAsId - Whether to use the agreementId as 'id' (true) or 'agreementId' (false) parameter when opening the dialog
 */
export default function ClickableAgreementId({
  agreementId,
  onAgreementUpdated,
  useAsId = false
}: ClickableAgreementIdProps) {
  const [open, setOpen] = useState(false);
  
  const handleClick = () => {
    setOpen(true);
  };
  
  const handleClose = () => {
    setOpen(false);
  };
  
  const handleSuccess = () => {
    if (onAgreementUpdated) {
      onAgreementUpdated();
    }
  };
  
  if (!agreementId) {
    return null;
  }
  
  return (
    <>
      <Tooltip title={`Open agreement: ${agreementId}`}>
        <IconButton
          onClick={handleClick}
          size="small"
          color="primary"
        >
          <DescriptionIcon />
        </IconButton>
      </Tooltip>
      <AgreementDialog
        open={open}
        onClose={handleClose}
        {... useAsId ? { id: agreementId } : { agreementId: agreementId }}
        onSuccess={handleSuccess}
      />
    </>
  );
}